import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { DELETE_INTENT_PROJECT } from "./gql";
import { SEARCH_INTENT_PROJECTS } from "../useSearchIntentProjects/gql";

const useDeleteIntentProject = () => {
  const { onError } = useTypedContext(FlashContext);

  const [deleteMutation, { loading, error }] = useMutation(DELETE_INTENT_PROJECT, {
    refetchQueries: [SEARCH_INTENT_PROJECTS],
  });

  const deleteIntentProject = useCallback(
    async (id: string) => {
      try {
        await deleteMutation({
          variables: { id },
        });
      } catch (error) {
        onError(error);
      }
    },
    [deleteMutation, onError]
  );

  return {
    deleteIntentProject,
    loading,
    error,
  };
};

export default useDeleteIntentProject;
